import {
  Box,
  BoxProps,
  Button,
  Dialog,
  DialogTitle,
  IconButton,
  Paper,
} from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const FilledButton = styled(Button)(() => ({
  borderRadius: '16px',
  width: '100%',
}));

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: '25px',
    backgroundColor: '#FFFFFF',
    minWidth: '860px',
    maxWidth: '90%',
    padding: '60px',
    minHeight: '500px',
  },
  '& .MuiDialog-paperScrollPaper': {
    '&::-webkit-scrollbar': {
      width: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.secondary.main,
      borderRadius: '10px',
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
    },
    '&::-webkit-scrollbar-track': {
      margin: '60px 0',
    },
  },
}));

export const TopBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row-reverse',
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  margin: '-40px -40px 0 0',
  '& span': {
    fontSize: '24px',
    fontWeight: '600',
    color: theme.palette.secondary.main,
  },
}));

export const StyledTitle = styled(DialogTitle)(({ theme }) => ({
  color: '#595959',
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontSize: '21px',
  fontWeight: '600',
  padding: '0',
  marginBottom: '20px',
  textTransform: 'uppercase',
  '& span': { color: theme.palette.secondary.main },
}));

export const PaperQuestions = styled(Paper)(({ theme }) => ({
  height: '540px',
  overflowY: 'auto',
  backgroundColor: '#FFFFFF',
  border: '1px solid #D7D8DB',
  borderRadius: '16px',
  '&.MuiPaper-root': {
    minWidth: '200px',
    padding: '8px 0',
    maxWidth: '100%',
  },
  '&::-webkit-scrollbar': {
    width: '12px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: '10px',
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
  '&::-webkit-scrollbar-track': {
    margin: '6px 0',
  },
  [theme.breakpoints.up('xl')]: {
    height: '660px',
  },
}));

interface QuestionsBoxProps extends BoxProps {
  open: boolean;
}

export const QuestionsBox = styled(Box)<QuestionsBoxProps>(
  ({ open, theme }) => ({
    cursor: 'pointer',
    backgroundColor: '#FFFFFF',
    ...(open && {
      backgroundColor: alpha(theme.palette.common.grey, 0.2),
    }),
  })
);

export const NavigationBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row-reverse',
  margin: '20px 40px',
  gap: '10px',
}));

export const OutlinedButton = styled(Button)(({ theme }) => ({
  minWidth: '32px',
  width: '48px',
  height: '42px',
  display: 'flex',
  border: `2px solid ${theme.palette.secondary.main}`,
  borderRadius: '16px',
  color: theme.palette.secondary.main,
  backgroundColor: '#FAFCFF',
  textTransform: 'lowercase',
  '&:disabled': {
    color: theme.palette.primary.main,
  },
}));
